<script>
    import { createEventDispatcher } from 'svelte';
    import { fade, fly } from 'svelte/transition';
    export let tipo='error';
    export let parpadea=false;
    export let animation=true;
    export let disableMarginBottom=false;
    export let valign='center';
    export let lheight='1';
    export let buttonClose=false;
    
    const dispatch = createEventDispatcher();

    function isAnimate()
    {
        if(animation===true)
        {
            return { y: -30, duration: 300 }
        } else {
            return { y: 0, duration:0 }
        }
    }
    function close()
    {
        dispatch('close', {});
    }
</script>
<svg xmlns="http://www.w3.org/2000/svg" style="display: none;">
    <symbol id="check-circle-fill" fill="currentColor" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z"/>
    </symbol>
    <symbol id="info-fill" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/>
    </symbol>
    <symbol id="exclamation-triangle-fill" fill="currentColor" viewBox="0 0 16 16">
      <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z"/>
    </symbol>
</svg>

{#if tipo=='info'}
    <div class="alert alert-primary d-flex p-2 lh-{lheight}" role="alert" 
        in:fly={isAnimate()}
        class:align-items-center={valign=='center'}
        class:align-items-top={valign=='top'}
        class:mb-0={disableMarginBottom===true}
        >
        <svg class="bi flex-shrink-0 me-2" class:parpadea={parpadea} width="24" height="24" role="img" aria-label="Info:"><use xlink:href="#info-fill"/></svg>
        <div>
            <slot/>
        </div>
    </div>
{:else if tipo=='success'}
    <div class="alert alert-success d-flex p-2 lh-{lheight}" role="alert"
        in:fly={isAnimate()}
        class:align-items-center={valign=='center'}
        class:align-items-top={valign=='top'}      
        class:mb-0={disableMarginBottom===true}
        >
        <svg class="bi flex-shrink-0 me-2" class:parpadea={parpadea} width="24" height="24" role="img" aria-label="Success:"><use xlink:href="#check-circle-fill"/></svg>
        <div>
            <slot/>
        </div>
    </div>
{:else if tipo=='warning'}
    <div class="alert alert-warning d-flex p-2 lh-{lheight}" role="alert"
        in:fly={isAnimate()}
        class:align-items-center={valign=='center'}
        class:align-items-top={valign=='top'}        
        class:mb-0={disableMarginBottom===true}
        >
        <svg class="bi flex-shrink-0 me-2" class:parpadea={parpadea} width="24" height="24" role="img" aria-label="Warning:"><use xlink:href="#exclamation-triangle-fill"/></svg>
        <div>
            <slot/>
        </div>
    </div>
{:else if tipo=='error'}
    <div class="alert alert-danger d-flex p-2 lh-{lheight}" role="alert"
        in:fly={isAnimate()}
        class:align-items-center={valign=='center'}
        class:align-items-top={valign=='top'}        
        class:mb-0={disableMarginBottom===true}
        >
        <svg class="bi flex-shrink-0 me-2" class:parpadea={parpadea} width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
        <div>
            <slot/>
        </div>
        {#if buttonClose===true}
            <button type="button" on:click={close} class="btn-close ms-auto" data-bs-dismiss="alert" aria-label="Close"></button>
        {/if}
        
    </div>   
{/if}


<style>
.parpadea {
  
  animation-name: parpadeo;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}
@keyframes parpadeo {  
  0% { opacity: 1.0; }
   50% { opacity: 0.0; }
  100% { opacity: 1.0; }
}
</style>


